/**
 * HTML module feature flag (build-time via REACT_APP_HTML_MODULE_ENABLED).
 *
 * When set to 'false', disables: module type picker entry, upload UI,
 * /htmlLink route, sidebar navigation for html modules, and HTML viewer.
 * Default: enabled when unset.
 */
const HTML_MODULE_TYPE = 'html';

export function isHtmlModuleEnabled() {
  return process.env.REACT_APP_HTML_MODULE_ENABLED !== 'false';
}

export function filterHtmlModuleRadios(radios) {
  if (isHtmlModuleEnabled()) {
    return radios;
  }
  return radios.filter((item) => item.value !== HTML_MODULE_TYPE);
}

export function filterHtmlModuleTypeTextMap(map) {
  if (isHtmlModuleEnabled()) {
    return map;
  }
  return map.filter((item) => item.value !== HTML_MODULE_TYPE);
}

export function filterHtmlModulesFromNav(modules) {
  if (isHtmlModuleEnabled()) {
    return modules;
  }
  return modules.filter((m) => m.type !== HTML_MODULE_TYPE);
}
